import React from 'react';
import { ICloudVen } from '../../domain/ven/interface';
import { ProgramTag } from '../ProgramTag';
import { SiteTag } from '../site/SiteTag';

export const VenDispatchType = ({ cloudVen }: { cloudVen: ICloudVen }) => {
    if (!cloudVen || !cloudVen.dispatch_type) return <></>;

    switch (cloudVen.dispatch_type) {
        case 'site':
            return (
                <>
                    {cloudVen?.sites?.map(site => (
                        <SiteTag value={site} key={site.site_id} />
                    ))}
                </>
            );

        case 'program':
            return (
                <>
                    {cloudVen.programs?.map((program, index) => (
                        <ProgramTag programName={program.name} key={program.program_id} />
                    ))}
                </>
            );

        case 'resource_id':
            return <></>;

        case 'group_id':
            return (
                <>
                    {cloudVen.programs?.map((program, index) => (
                        <ProgramTag programName={program.name} key={program.program_id} />
                    ))}
                </>
            );

        default:
            return <></>;
    }
};
